import Vue from "vue/dist/vue.esm.js";
import http from "./http";
import message from "./message";
import helper from "./helper";
import util from "./util";
import blob from "./blob";

// 将工具类注册到Vue的实例中
Vue.use({
    install(Vue, options) {
        Vue.prototype["$FG_http"] = http;
        Vue.prototype["$FG_message"] = message;
        Vue.prototype["$FG_helper"] = helper;
        Vue.prototype["$FG_util"] = util;
        Vue.prototype["$FG_blob"] = blob;
    }
});
